/** Select Branch value for company-level scope (no branch id). */
export const MAIN_COMPANY_SCOPE_VALUE = 'main_company'

export function isMainCompanyScope(selectedBranchId) {
  return String(selectedBranchId || '') === MAIN_COMPANY_SCOPE_VALUE
}

export function hasBranchScopeSelection(selectedBranchId) {
  const id = String(selectedBranchId || '').trim()
  return id !== '' && !isMainCompanyScope(id)
}
